import { Directive } from "vue";

export const vLazy: Directive = {
  // 'created' hook runs before attributes are applied in Vue 3
  // This ensures loading="lazy" is set before the browser starts fetching 'src'
  created(el: HTMLElement) {
    if (el.tagName.toLowerCase() === "img") {
      el.setAttribute("loading", "lazy");
    }
  },
};
